import React, { useState } from 'react';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import { truncateString } from '../../helpers/helper';
import student_sample_file from '../../assets/student_sample_file.csv';
import { addStudent as addStudentAction } from '../../actions/admin.actions';
import CircularProgress from '@mui/material/CircularProgress';
import DownloadIcon from '@mui/icons-material/Download';
import UploadIcon from '@mui/icons-material/Upload';
const AddStudent = ({ handleTabChange }) => {
    const fileInputRef = React.useRef();
    const [file, setFile] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(null);
    const [submitError, setSubmitError] = useState(null);

    const handleDragOver = (event) => {
        event.preventDefault();
        event.stopPropagation();
    }

    const handleDrop = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const files = Array.from(event.dataTransfer.files);
        const csvfFiles = files.filter(file => file.type === 'text/csv');
        if (csvfFiles.length) {
            setFile(csvfFiles[0]);
        }
    }

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);
        const csvfFiles = files.filter(file => file.type === 'text/csv');
        if (csvfFiles.length) {
            setFile(csvfFiles[0]);
        }
    }

    const handleFileRemove = () => {
        setFile(null);
        fileInputRef.current.value = '';
    }

    const handleReset = () => {
        setFile(null);
        fileInputRef.current.value = '';
    }

    const handleDownloadSample = () => {
        const link = document.createElement('a');
        link.href = student_sample_file;
        link.download = 'student_sample_file.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    const handleSubmit = () => {
        if (!file) {
            setSubmitError('Please select a file');
            return;
        }
        if (submitting) return;

        setSubmitError(null);
        setSubmitting(true);
        const formData = new FormData();
        formData.append('file', file);
        addStudentAction(formData).then(res => {
            setSubmitting(false);
            if (res.data.status) {
                setSubmitSuccess(res.data.message);
                handleFileRemove();
                setTimeout(() => {
                    setSubmitSuccess(null);
                    handleTabChange(null, 1);
                }, 2000);
            } else {
                setSubmitError(res.data.message);
            }
        }).catch(error => {
            setSubmitError('Something went wrong');
            setSubmitting(false);
        });

    }

    return (
        <>
            <div className='row'>
                <div className='copy-sec-modal logout-sec-modal add-club-sec app-club-sec nwe-admn-min' style={{ paddingTop: '0px' }}>
                <div className='csv-sec'>
                    <div className='csv-sample-sec csv-newss'>
                    <a className="downnn-newss" onClick={handleDownloadSample} >Download CSV Sample <DownloadIcon /></a>
                            <button type='button' onClick={() => handleTabChange(null, 0, null, false, false)} className='down-sec-adm bulk-upp'>Add Student </button>
                       
                    {/* <button type='button' onClick={handleDownloadSample} className='down-sec-adm'>Download CSV Sample</button> */}
                    </div>
                    </div>
                    <h2 className='uplod-secddd new-upld new-admn'>Please upload CSV File</h2>
                   
                    <div
                        className="formbold-file-input admn-inptsec"
                        onDragOver={handleDragOver}
                        onDrop={handleDrop}
                    >
                        <input
                            type="file"
                            name="file"
                            id="file"
                            accept=".csv"
                            ref={fileInputRef}
                            onChange={handleFileChange}
                        />
                        <label htmlFor="file">
                            <div className="upload-label-sec">
                                <a> <CloudUploadIcon /></a>
                                <div className="bros-sec">
                                    <p className="formbold-drop-file">Upload File </p>
                                    <p className="formbold-drop-file">Drag and Drop File </p>
                                </div>
                            </div>
                        </label>
                        <p className='only-csv'>Only CSV file Supported</p>
                    </div>
                    {
                        file &&
                        <div>
                            <ul className='list-group'>
                                <li className='list-group-item list-app listnewpad'>
                                    {truncateString(file.name, 35)}
                                    <DeleteIcon onClick={handleFileRemove} />
                                </li>
                            </ul>
                        </div>
                    }

                </div>
            </div>

            <div className='row'>
                <div className='col-md-12'>
                    <div className="login-submit login-submitss btn-adm adn-btn">
                        <button className="btn btn-login btn-submit bt-forms" type='button' onClick={handleSubmit}>Submit {submitting && <CircularProgress style={{ width: "15px", height: "15px", marginLeft: "5px", color: "white" }} />}</button>
                        {
                            !submitting &&
                            <button className="btn btn-login btn-submit bt-forms btn-reset" type='button' onClick={handleReset}>Reset</button>
                        }
                        
                    </div>
                </div>
            </div>
            {
                submitSuccess ?
                    <div className="custome-vali custom-success-msg">
                        {submitSuccess}
                    </div>
                    : null
            }
            {
                submitError ?
                    <div className="custome-vali custom-error-msg" >
                        {submitError}
                    </div>
                    : null
            }
        </>
    )

}

export default AddStudent;